import { Button, DialogActions, DialogContent, DialogTitle, Modal, ModalDialog, Textarea } from "@mui/joy";
import React from "react";
import WrappedButton from "../WrappedButton";

interface PackingListNotesDialogProps {
	open: boolean;
	packingListId: string;
	initialNotes: string;
	onClose: () => void;
	onSaved: () => void;
}

/**
 * Dialog component for editing packing list notes
 * Displays a textarea for entering notes and saves to the API
 */
export default function PackingListNotesDialog(props: PackingListNotesDialogProps) {
	const [notes, setNotes] = React.useState(props.initialNotes);
	const [isSaving, setIsSaving] = React.useState(false);

	// Reset notes when dialog opens with new data
	React.useEffect(() => {
		setNotes(props.initialNotes);
	}, [props.initialNotes, props.packingListId]);

	/**
	 * Saves notes for the packing list via API call
	 */
	const saveNotes = () => {
		setIsSaving(true);
		fetch("PackingList/SavePackingListNotes", {
			method: "POST",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				packingListId: props.packingListId,
				notes: notes,
			}),
		}).then(() => {
			setIsSaving(false);
			props.onSaved();
		});
	};

	return (
		<Modal open={props.open}>
			<ModalDialog sx={{ width: 600 }}>
				<DialogTitle>Notes</DialogTitle>
				<DialogContent>
					<Textarea
						value={notes}
						onChange={(e) => setNotes(e.target.value)}
						minRows={10}
						placeholder="Enter notes here..."
						sx={{ width: "100%" }}
					/>
				</DialogContent>
				<DialogActions>
					<WrappedButton onClick={saveNotes} busy={isSaving}>
						Save
					</WrappedButton>
					<Button onClick={props.onClose} color="primary">
						Close
					</Button>
				</DialogActions>
			</ModalDialog>
		</Modal>
	);
}
